import { Pagination } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import {  GrFormNextLink } from "react-icons/gr";

import {  GET_PRODUCTS } from "../../Utils/Queries";
import { Box,  Typography, useMediaQuery, useTheme } from "@mui/material";
import Masonry from "@mui/lab/Masonry";
import ProductsCardMansory from "../Cards/ProductCardMansory";
import CardLoader from "../Cards/CardLoader";

const LatestProducts = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [pagination, setPagination] = useState({ current: 1, pageSize: 100 });
  const { error, data, loading } = useQuery(GET_PRODUCTS, {
    variables: {
      page: pagination.current,
      limit: pagination.pageSize,
    },

  });

  const products =
    data?.listAllAvailableProductsWithoutAuthentication?.items || [];

  const totalItems =
    data?.listAllAvailableProductsWithoutAuthentication?.pagination
      ?.totalItems || 0;

  const handlePaginationChange = (page, pageSize) => {
    setPagination({ current: page, pageSize });
  };


  const renderProducts = () => {
    if (error) return <Typography>No Products Found</Typography>;
    if (!loading && products.length === 0)
      return <Typography>No available products at the moment.</Typography>;

    return (
      <>
        {loading ? (
          <CardLoader />
        ) : (
          <Masonry
            defaultColumns={{ lg: 6, sm: 4, xs: 2 }}
            defaultHeight={450}
            columns={{ lg: 6,md:6, sm: 4, xs: 2 }}
            spacing={2}
            sx={{ mt: 2, width: "100%", mx: 0 }}
          >
            {products.map((product, idx) => (
              <Box>
                {idx === 10 ? (
                  <Link to="/sell-on-mamaket">
                    <Box
                      sx={{
                        bgcolor: "#2E1833",
                        height: "100px",
                        borderRadius: "8px",
                        p: 2,
                        boxSizing: "border-box",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "20px",
                          color: "#fff",
                          fontWeight: 700,
                          lineHeight: "20px",
                        }}
                      >
                        Sell on Mamaket
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "end" }}>
                        <Typography>
                          Join as a Vendor. Start Earning{" "}
                        </Typography>{" "}
                        <GrFormNextLink style={{ color: "#fff" }} />
                      </Box>
                    </Box>
                  </Link>
                ) : idx === 24 ? (
                   <Link to="/sell-on-mamaket">
                    <Box
                      sx={{
                        bgcolor: "#2E1833",
                        height: "100px",
                        borderRadius: "8px",
                        p: 2,
                        boxSizing: "border-box",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "20px",
                          color: "#fff",
                          fontWeight: 700,
                          lineHeight: "20px",
                        }}
                      >
                        Sell on Mamaket
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "end" }}>
                        <Typography>
                          Join as a Vendor. Start Earning{" "}
                        </Typography>{" "}
                        <GrFormNextLink style={{ color: "#fff" }} />
                      </Box>
                    </Box>
                  </Link>
                ) : (
                  <Link
                    key={idx}
                    to={`/product-view/${product._id}`}
                    style={{ textDecoration: "none" }}
                  >
                    <ProductsCardMansory
                      image={product.images?.[0]}
                      images={product.images}
                      price={product.price.toLocaleString()}
                      flag={product?.country?.flagUrl}
                      title={product?.name}
                      ratings={product?.rating}
                      description={product?.description}
                    />
                  </Link>
                )}
              </Box>
            ))}
          </Masonry>
        )}
      </>
    );
  };

  return (
    <Box
      sx={{
        p: { md: 2, xs: 1 },
        pb: 4,
        my: 3,
        bgcolor: "#f2f2f2",
        boxShadow:
          "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
        borderRadius: "5px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: { xs: "16px", sm: "18px", md: "24px" },
            fontWeight: 700,
          }}
        >
          Our Latest Products
        </Typography>
      </Box>

      {renderProducts()}

      {!!totalItems && (
        <Box
          mt={4}
          display="flex"
          justifyContent="center"
          className="pagination-container"
        >
          <Pagination
            total={totalItems}
            current={pagination.current}
            pageSize={pagination.pageSize}
            showSizeChanger={false}
            onChange={handlePaginationChange}
          />
        </Box>
      )}
    </Box>
  );
};

export default LatestProducts;
